module.exports = __webpack_public_path__ + "img/waiting-room.12a6324f.webp";